export const SubsConventionContentSections =  {
    description: "Descrizione",
    files: "Documenti",
    more_info: "Ulteriori informazioni"
}

export class SubsConventionClass {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
        this.description = data.description;
        this.date_published = data.date_published;
        this.last_update = data.last_update;
        this.content = data.content;
        this.user = data.user;
    }   
}